package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_05_26_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-05-26")
@Composable
public fun Log_2023_05_26(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Battle in the Stables",
        ogTitle = "Battle in the Stables",
        date = LocalDate(2_023, 5, 26),
        ogDescription = "A Beholder-like Spectator and more Vrocks ambush the party in the Darkway, forcing a desperate magical defense.",
        ogImage = "ai/2023-05-26.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-28", dateString = "Newgrowth 28")
        Log_2023_05_26_Day_1()
    }
}
